import { Component, EventEmitter, Injector, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Art57Section } from '../../ui/Art57Section/Art57Section';
import { IMPORT_TYPE, WebtraderService } from '../../service/webtrader-service/webtrader.service';

@Component({
  selector: 'app-local-file-selector',
  templateUrl: './local-file-selector.component.html',
})
export class LocalFileSelectorComponent {

  @Output() fileContentChange = new EventEmitter<string>();

  selectedFile: File | null = null;
  fileContent: string = '';
  selectedFileName: string = '';

  constructor(
    private injector: Injector) {
  }

  initComponent() {
    this.selectedFile = null;
    this.selectedFileName = '';
    this.fileContent = '';
    this.fileContentChange.emit(this.fileContent);
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length) {
      this.selectedFile = input.files[0];

      if (this.selectedFile.type === 'application/xml' || this.selectedFile.name.toLowerCase().endsWith('.xml')) {

        this.selectedFileName = this.selectedFile.name;
        const maxSizeInBytes = 60 * 1024 * 1024; // 60 MB in bytes 
        if (this.selectedFile && this.selectedFile.size <= maxSizeInBytes) {

          this.injector.get(WebtraderService).import(this.selectedFile, IMPORT_TYPE.EVPRM).subscribe(
            {
              next: (message) => {
                if (message) {
                  this.fileContent = JSON.stringify(message);
                  this.fileContentChange.emit(this.fileContent);
                }
              },
              error: (error) => {
                 this.injector.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'The message is not validated against the xsd file', lifecycle: environment.errorElapsedTime });
              }
            });

        } else if (this.selectedFile.size > maxSizeInBytes) {
          this.initComponent();
          this.injector.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'Selected file is greater than 60Mb', lifecycle: environment.errorElapsedTime });
        }
      } else {
        this.initComponent();
        this.injector.get(Art57Section).showTooltipMessage({ severity: 'error', detail: 'XEVPRM contains error(s), invalid message structure.', lifecycle: environment.warningElapsedTime });
      }
    }
  }

  acceptTypes(): string {
    return '.xml'; // Tipos de archivo admitidos
  }
}